import { useState } from "react";
import { api, fmtEur, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Pencil } from "lucide-react";
import { toast } from "sonner";

const parse = (s) => {
  const t = String(s).trim().replace(/\s|€/g, "");
  const n = Number(t.includes(",") ? t.replace(/\./g, "").replace(",", ".") : t);
  return t === "" || Number.isNaN(n) ? null : n;
};

export const SaldoPrecedente = ({ c, editable, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState("");
  const save = async (saldo) => {
    try {
      await api.put(`/conteggi/${c.padroncino_id}/saldo-precedente`, { mese: c.mese, saldo });
      toast.success(saldo === null ? "Saldo precedente ricalcolato" : "Saldo precedente salvato");
      setOpen(false); onSaved();
    } catch (e) { toast.error(formatErr(e)); }
  };
  const submit = () => {
    const n = parse(val);
    if (n === null) { toast.error("Scrivi un importo, es. -1250,50"); return; }
    save(n);
  };
  return (
    <div className="border rounded-sm p-2.5" data-testid="conteggi-saldo-prec">
      <div className="flex items-center justify-between text-xs font-heading uppercase tracking-wider text-muted-foreground">
        <span>Saldo prec.{c.saldo_manuale && <span className="ml-1 normal-case text-primary" data-testid="conteggi-saldo-prec-manuale">· manuale</span>}</span>
        {editable && c.saldo_modificabile && (
          <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) setVal(String(c.saldo_precedente).replace(".", ",")); }}>
            <PopoverTrigger asChild>
              <button type="button" className="hover:text-foreground" title="Modifica saldo precedente" data-testid="conteggi-saldo-prec-edit"><Pencil className="w-3.5 h-3.5" /></button>
            </PopoverTrigger>
            <PopoverContent className="w-72 space-y-2" align="start">
              <div className="text-sm font-medium">Saldo precedente di questo mese</div>
              <p className="text-xs text-muted-foreground">Negativo = il padroncino ci deve, positivo = a suo favore. I mesi dopo partono dal saldo finale di questo mese.</p>
              <Input autoFocus value={val} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} placeholder="es. -1250,50" data-testid="conteggi-saldo-prec-input" />
              <div className="flex justify-between gap-2">
                {c.saldo_manuale ? <Button size="sm" variant="ghost" onClick={() => save(null)} data-testid="conteggi-saldo-prec-reset">Torna al calcolo</Button> : <span />}
                <Button size="sm" onClick={submit} data-testid="conteggi-saldo-prec-save">Salva</Button>
              </div>
            </PopoverContent>
          </Popover>
        )}
      </div>
      <div className="font-mono font-bold text-base text-foreground" data-testid="conteggi-saldo-prec-value">{fmtEur(c.saldo_precedente)}</div>
    </div>
  );
};
